import styled from 'styled-components';
import { ThemeType } from '../../../types/Theme';

const InformacoesArquivoContainer = styled.div<{theme: ThemeType}>`
    color: ${({theme}) => theme.colors.tertiary};
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: flex-start;
    align-items: flex-start;
    .informacao{
        display: flex;
        gap: 1rem;
        span{
            width: 2rem;
            color: ${({theme}) => theme.colors.brandDanger};
        }
        .accept{
            color: ${({theme}) => theme.colors.primary};
        }
    }
    .ajustar-produtos{
        color: ${({theme}) => theme.colors.tertiary};
        padding: 0.5rem;
        background-color: ${({theme}) => theme.colors.elements};
    }
`;

export {
    InformacoesArquivoContainer
};

